<template>
  <div class="invalid-feedback">
    <div v-if="typeof errors === 'string'">
      {{ errors }}
    </div>
    <div
      v-else
      v-for="(error, index) in errors"
      :key="index"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      required: true,
      type: [String, Array],
    },
  },
}
</script>
